import * as React from 'react';
import { Button, Form, Input, Radio, Table, Image, Icon, Checkbox, Container } from 'semantic-ui-react'
import moment from 'moment';

import CustomDatePicker from './CustomDatePicker';
import Loader from './Loader';

import formats from '../helpers/formats';

import resultadosService from '../services/resultados.service';

class ResultadosMedico extends React.Component {
    constructor(props) {
        super(props)

        try {
            const localState = localStorage.getItem('state');

            if (localState) {
                const state = JSON.parse(localState);
                localStorage.removeItem('state');
                this.state = { ...state };
            } else {
                this.state = {
                    isLoading: false,
                    paciente: '',
                    tipoFiltro: 0,
                    dataInicial: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                    dataFinal: moment().format('YYYY-MM-DD'),
                    resultados: []
                };
            }
        } catch (e) {
            this.state = {
                isLoading: false,
                paciente: '',
                tipoFiltro: 0,
                dataInicial: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                dataFinal: moment().format('YYYY-MM-DD'),
                resultados: []
            };
        }
    }

    onClickFiltrar = async () => {

        try {
            this.setState({ isLoading: true });

            const { paciente, tipoFiltro, dataInicial, dataFinal } = this.state;

            const { data: resultados } = await resultadosService.getResultadosFiltro({ paciente, tipoFiltro, dataInicial, dataFinal });

            this.setState({ isLoading: false, resultados }, () => localStorage.setItem('state', JSON.stringify(this.state)));

        } catch (err) {
            console.log(err);
            this.props.history.push('/');
        }
    }

    onPressAtendimento = async (atendimento) => {
        if (atendimento.disponivel) {

            this.setState({ ...this.state, isLoading: true });

            try {
                await resultadosService.getLaudo(atendimento);
            } catch (error) {
                console.log(error);
            }

            this.setState({ ...this.state, isLoading: false });
        }
    }

    render() {

        const verificado = require('../img/verificado-sm.png');
        const andamento = require('../img/andamento-sm.png');
        const parcial = require('../img/parcial-sm.png');

        return (<Container className='formResultMedico'>

            <Form >

                <Form.Field control={Input}
                    placeholder='Todos os pacientes'
                    className='inputBuscaPaciente'
                    onChange={(e) => this.setState({ ...this.state, paciente: e.target.value })} />
                <Form.Field control={CustomDatePicker} label='Data inicial'
                    selectedDate={this.state.dataInicial}
                    onChangeDate={dataInicial => this.setState({ dataInicial })} />
                <Form.Field control={CustomDatePicker} label='Data final'
                    selectedDate={this.state.dataFinal}
                    onChangeDate={dataFinal => this.setState({ dataFinal })} />
                <Form.Field className='inputBuscaPaciente' control={Button} onClick={() => this.onClickFiltrar()}>Filtrar</Form.Field>


                <label>Opções de Filtro</label>
                <Form.Group inline>
                    <Form.Field
                        control={Radio}
                        label='Todos'
                        checked={this.state.tipoFiltro === 0}
                        onChange={() => this.setState({ ...this.state, tipoFiltro: 0 })}
                    />
                    <Form.Field
                        control={Radio}
                        label='Laudos Não Lidos'
                        checked={this.state.tipoFiltro === 1}
                        onChange={() => this.setState({ ...this.state, tipoFiltro: 1 })}
                    />
                    <Form.Field
                        control={Radio}
                        label='Laudos Lidos'
                        checked={this.state.tipoFiltro === 2}
                        onChange={() => this.setState({ ...this.state, tipoFiltro: 2 })}
                    />
                </Form.Group>
            </Form>
            <Container className='listaExamesMedico'>
                <Table celled striped>
                    <Table.Header />
                    <Table.Body>
                        {this.state.resultados.map((item, index) =>
                            <Table.Row key={index} onClick={() => this.onPressAtendimento(item)}>
                                <Table.Cell collapsing>
                                    <Icon name='file outline' />{item.ateCod}
                                </Table.Cell>
                                <Table.Cell collapsing>{formats.toDate(item.ateData)}</Table.Cell>
                                <Table.Cell>{item.pacNome}</Table.Cell>
                                <Table.Cell textAlign='left' collapsing>
                                    <Image.Group >
                                        <Image src={item.disponivel ? (item.possuiLaudoPendente ? parcial : verificado) : andamento} />
                                        <Image src={require('../img/icon-pdf-sm.png')} />
                                        <Checkbox readOnly={true} checked={item.possuiResultadoLido} />
                                    </Image.Group>
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </Container>
            <Loader isLoading={this.state.isLoading} />
        </Container>
        )
    }
}

export default ResultadosMedico;